<template>
  <div class="bg-white common-margin-top common-padding-2"></div>
  <!--<div class="bg-white common-margin-top common-padding-2">
    <div class="div-center common-body-width container">
      <div class="text-center font-18">合作伙伴</div>
      <div class="common-margin-top common-margin-bottom">
        <div class="row">
          <div class="col col-6 col-md-3 col-lg-2 font-28">美券花</div>
          <div class="col col-6 col-md-3 col-lg-2 font-28">易支付</div>
          <div class="col col-6 col-md-3 col-lg-2 font-28">蜂鸟商圈</div>
          <div class="col col-6 col-md-3 col-lg-2 font-28">猎龙商城</div>
          <div class="col col-6 col-md-3 col-lg-2 font-28">藏宝天下</div>
          <div class="col col-6 col-md-3 col-lg-2 font-28">全返商城</div>
        </div>
      </div>
    </div>
  </div>-->
</template>

<script>
export default {
  name: 'CommHeader'
}
</script>



// WEBPACK FOOTER //
// src/components/CommBrand.vue